// 土耳其
export default {
    login: {
        t01: 'Dil',
        t02: 'Netflix',
        t03: 'Kullanıcı adı girin',
        t04: 'Parola girin',
        t05: 'Giriş Yap',
        t06: 'Kaydol',
        t07: 'Telefon numarasını girin',
        t08: 'Şifre onayı girin',
        t09: 'Davet kodunu girin',
        t10: 'Hesap oluştur',
        t11: 'Parola onaylayın',
        t13: 'Sinemaya duyulan sevgi, farkına varmadan hatırı sayılır bir servet biriktirmeni sağlayabilir.',
        t14: 'Giriş başarılı',
        t15: 'Şifreler eşleşmiyor',
        t16: 'Kayıt başarılı',
        t17: 'Ağ hatası',
        t18: 'İstek zaman aşımı, lütfen internet bağlantınızı kontrol edin'
    },
    cover_info: {
        t01: 'Para kazanmaya başla',
        t02: 'Altın para yükle',
        t03: 'Altın parayı çek',
        t04: 'Sertifikalar'
    },
    cont: {
        t01: 'Dil Seçin',
        t02: 'Tümü',
        t03: 'Bekleyen',
        t04: 'Tamamlandı',
        t05: 'Askıda',
        t06: 'Hesap Bakiyesi',
        t07: 'Tamamlanmamış',
        t08: 'Toplam Sipariş Tutarı',
        t09: 'Komisyon',
        t10: 'Kazanç',
        t11: 'Sipariş Sayısı',
        t12: 'Mevcut Bakiye',
        t13: 'Sipariş Almaya Başlayın',
        t14: 'Hesap Fonları',
        t15: 'Siparişi Gönderin',
        t16: 'Tüm Siparişleri Gönderin',
        t17: 'Sipariş Alma Saati',
        t18: 'Sipariş Numarası',
        t19: 'Toplam Sipariş Tutarı',
        t21: 'Eser',
        t22: 'Oyuncu',
        t23: 'Eser yorumları',
        t24: 'İptal',
        t25: 'Değerlendirme Seçin',
        t26: 'Sipariş Gönderimi Tamamlandı',
        t27: 'Sipariş Alındı',
        t28: 'Sipariş Alma Başarılı Oldu',
        t29: 'Sipariş Alma Başarısız Oldu, Tekrar Deneyin!'
    }
    ,
    user: {
        t1: 'Tanıtım Kodu',
        t2: 'Bakiye',
        t3: 'Kullanılabilir Bakiye',
        t4: 'Toplam Kazanç',
        t5: 'Para Çekme',
        t6: 'Yatırım Geçmişi',
        t7: 'Çekim Geçmişi',
        t8: 'Hesap Bilgileri',
        t9: 'Mesaj',
        t10: 'Banka Kartı Bağla',
        t11: 'Şifre Değiştir',
        t12: 'Para Çıkış Şifresini Değiştir',
        t13: 'Arkadaş Davet Et',
        t14: 'Dil Seçimi',
        t15: 'Çıkış Yap',
        t16: 'Para Çek',
        t17: 'Çekebileceğiniz Para Miktarı',
        t18: 'Hesap İsmi',
        t19: 'Telefon Numarası',
        t20: 'Para Çıkma Miktarı',
        t21: 'Para Çek',
        t22: 'Lütfen para çekme miktarını girin',
        t23: 'Sanal Para Şifresini Girin',
        t24: 'Toplam Yatırım',
        t25: 'Sistem Mesajları',
        t26: 'Banka Kartı Bilgileri',
        t27: 'Banka Listesi',
        t28: 'Banka Adı',
        t29: 'Aile Adı',
        t30: 'Banka Kartı Numarası',
        t31: 'Telefon Numarası',
        t32: 'Değişiklikleri Onayla',
        t33: 'Lütfen bağlantılı banka kartınızın hesap numarasını ve IFSC numarasını girin, aynı zamanda adınızı ve telefon numaranızı doğru şekilde doldurun, aksi takdirde yatırım miktarı ulaşmayacaktır.',
        t34: 'Eski Şifre',
        t35: 'Yeni Şifre',
        t36: 'Şifre Onayı',
        t37: 'Devam Et',
        t38: 'Lütfen şifrenizi unutmadığınızdan emin olun, eğer unuttuysanız müşteri hizmetleriyle iletişime geçin.',
        t39: 'Davet Linki Kopyala',
        t40: 'Para kazanmak için arkadaşları davet et',
        t41: 'Yatırım Yap',
        t42: 'Onayla',
        t43: 'Vazgeç',
        t44: 'Çıkış Yapacak Mısınız?',
        t45: 'Yatırım Miktarı',
        t46: 'Yatırım Başarılı',
        t47: 'Doğrulandı',
        t48: 'Doğrulanmayı Bekliyor',
        t49: 'Toplam Para Çekme',
        t50: 'Önce para çekme şifresini ayarlayın',
        t51: 'Lütfen eski şifrenizi girin',
        t52: 'Lütfen yeni şifreyi girin',
        t53: 'Lütfen şifre onayını girin',
        t54: 'Girilen iki şifre uyuşmuyor',
        t55: 'Kopyalandı',
        t56: 'Para çekme miktarı 30\'dan az olamaz',
        t57: 'Başarıyla gönderildi, yönlendiriliyor',
        t58: 'İnceleme başarısız oldu',
        t59: 'Profil Fotoğrafı Ayarla',
        t60: 'Şimdi Ayarla',
        t61: 'Başarıyla Ayarlandı',
        t62: 'Cüzdan onaylandıktan sonra parayı çekmek için giriş yapmanız gerekmektedir',
        t63: 'Banka kartına para çekme',
        t64: 'USDT ye çekim (oran 1:0.013)',
        t65: 'Bank Hesap Numarası',
        t66: 'Lütfen bağlamak istediğiniz banka kartı için banka hesap numaranızı ve IFSC kodunu girin, ayrıca tam adınızı ve cep telefonu numaranızı doğrulayın. Tüm bilgileri doğru olsun diye ödeme işlemleri kolayca gerçekleşecek şekilde.',
        t67: 'Lütfen önce banka kartı bağlayın',
        t68: 'Kullanıcı yüklemesi',
        t69: 'Kullanıcı siparişi',
        t70: 'Alt seviye komisyonu',
        t71: 'Kullanıcı para çekme',
        t72: "Yu'e Bao transferi",
        t73: "Yu'e Bao çekimi",
        t74: "Yu'e Bao kazancı",
        t75: 'Sipariş komisyonu',
        t76: 'Bakiye 30\'dan düşük, işleme devam edilemiyor, lütfen müşteri hizmetleri ile iletişime geçin',
        t77: 'Lütfen banka adını girin',
        t78: 'Lütfen banka hesap numarasını girin',
        t80: 'Lütfen tam adınızı girin',
        t81: 'Lütfen telefon numaranızı girin',
        t82: 'Lütfen para çekme miktarını girin',
        t83: 'Kopyala',
        t84: 'Günlük En İyi 100: Küresel',
        t85: 'Dinlemek',
        t86: "E-posta",
        t87: "Lütfen e-posta adresinizi girin",
        "t88": "Banka Kodu",
        "t89": "Lütfen banka kodunu girin",
        t90: 'Banka havalesi',
        t91: '1. Para çekimlerde herhangi bir ücret alınmaz',
        t92: '2. Çekim işlemi, çekimden sonra 10 ila 15 dakika içinde başarıyla hesabınıza geçer. Mesai saatleri dışında yapılan çekimler bir sonraki mesai saatlerinde hesabınıza geçer.'
    },
    movie: {
        t01: 'Popüler filmler ve TV programları',
        t02: 'Fon şifresi',
        t03: 'Sipariş farkı',
        t04: 'Zincir üstü adres yönetimi',
        t05: 'Lütfen girin',
        t06: 'Lütfen doğru zincir üstü adresi ve ilgili ağı (örn. ERC20/TRC20/BTC) girin; aksi takdirde ödeme/transfer ulaşmayabilir veya varlık kaybına neden olabilir.',
        t07: 'Zincir üstü adrese çekim',
        t08: 'Lütfen ekleyin',
        t09: 'Lütfen zincir üstü adres ekleyin',
    },
    langType: '土耳其语'
}
